import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { ActionType, IDisplayLogicEditModel } from '../../../models';
import * as QuestionBranchingLogicAPI from '../../../services/QuestionDisplayLogicAPI';
import { IApplicationState } from '../../../store';
import { FormattedDraggableHeaderRow, FormattedDraggableTh } from './FormattedDesignTable';
import { QuestionDisplayLogicDrawerCondition } from './QuestionDisplayLogicDrawerCondition';

const RuleContainer = styled.div`
	background-color: ${globalVars.tertiaryGray3};
	color: ${globalVars.mainGray};
	font-size: ${globalVars.fontSizeMedium};
	font-weight: ${globalVars.fontWeightNormal};
	width: 94%;
	margin-bottom: 30px;
	border-left: 10px solid ${globalVars.tertiaryBlue2};
	border-bottom-left-radius: 4px;
	border-top-left-radius: 4px;
	margin-right: 20px;
	margin-left: 30px;
	position: relative;
`;
RuleContainer.displayName = 'RuleContainer';

const LocalFormattedTh = styled(FormattedDraggableTh)`
	margin-left: 30px;
`;
LocalFormattedTh.displayName = 'LocalFormattedTh';

export const QuestionDisplayLogicDrawer = (props: {
	surveyQuestionId: number;
	ToggleDisplayLogicModal?: (isOpen: boolean, surveyQuestionId: number) => void;
}) => {
	const { surveyId } = useSelector((state: IApplicationState) => state.surveyBuilder);
	const { surveyQuestionId, ToggleDisplayLogicModal } = props;
	const [branchingLogicEditModels, setBranchingLogicEditModels] = useState<IDisplayLogicEditModel[]>([]);

	React.useEffect(() => {
		async function loadBranchingLogic() {
			const result = await QuestionBranchingLogicAPI.GetQuestionDisplayLogic(surveyId, surveyQuestionId);
			setBranchingLogicEditModels(result[surveyQuestionId] ?? []);
		}

		if (surveyId > 0 && surveyQuestionId > 0) {
			loadBranchingLogic();
		}
	}, [surveyQuestionId, surveyId]);

	return (
		<>
			{branchingLogicEditModels.map((item: IDisplayLogicEditModel, ruleIndex) => {
				const action = item.displayLogicRule.displayLogicAction;

				return (
					<React.Fragment key={`${surveyQuestionId}-${item.displayLogicRule.displayLogicRuleId}-${action.actionType}`}>
						<FormattedDraggableHeaderRow>
							<FormattedDraggableTh flexBasis={0} />
							<FormattedDraggableTh flexBasis={0}>{ContentConstants.TABLE_HEADER_LOGIC}</FormattedDraggableTh>
							<LocalFormattedTh flexBasis={94}>{ContentConstants.TABLE_HEADER_CONDITION}</LocalFormattedTh>
						</FormattedDraggableHeaderRow>
						<RuleContainer
							key={item.displayLogicRule.displayLogicRuleId}
							role='group'
							aria-label={`Branching Logic Rule ${ruleIndex + 1} for Question ${surveyQuestionId}`}
						>
							{item.displayLogicConditions.map((c, index) => {
								if (index === 0 && action.actionType === ActionType.BranchToQuestion) {
									return (
										<React.Fragment key={index}>
											<QuestionDisplayLogicDrawerCondition
												destinationQuestionId={action.destinationQuestionId}
												surveyQuestionId={surveyQuestionId}
												condition={c}
												actionType={action.actionType}
												showRule={index === 0}
												ToggleDisplayLogicModal={ToggleDisplayLogicModal}
											/>
											<QuestionDisplayLogicDrawerCondition
												destinationQuestionId={action.destinationQuestionId}
												surveyQuestionId={surveyQuestionId}
												condition={c}
												actionType={action.actionType}
												showRule={false}
												ToggleDisplayLogicModal={ToggleDisplayLogicModal}
											/>
										</React.Fragment>
									);
								} else {
									return (
										<QuestionDisplayLogicDrawerCondition
											destinationQuestionId={action.destinationQuestionId}
											surveyQuestionId={surveyQuestionId}
											condition={c}
											key={index}
											actionType={action.actionType}
											showRule={index === 0}
											ToggleDisplayLogicModal={ToggleDisplayLogicModal}
										/>
									);
								}
							})}
						</RuleContainer>
					</React.Fragment>
				);
			})}
		</>
	);
};
